<script lang="ts">
	import { onDestroy } from 'svelte'

	interface Props {
		focusIndex: number
		lastItemIndex: number
		children?: import('svelte').Snippet
	}

	let { focusIndex = $bindable(), lastItemIndex, children }: Props = $props()

	const itemsOnPage = 8

	let optionsCover: HTMLDivElement = $state(null)

	function handleKeyDown(event: KeyboardEvent) {
		if (['ArrowDown', 'ArrowUp', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.code)) {
			switch (event.code) {
				case 'Home':
					focusIndex = 0
					break
				case 'End':
					focusIndex = lastItemIndex
					break
				case 'ArrowUp':
					focusIndex--
					break
				case 'ArrowDown':
					focusIndex++
					break
				case 'PageUp':
					focusIndex = focusIndex - itemsOnPage
					break
				case 'PageDown':
					focusIndex = focusIndex + itemsOnPage
					break
			}

			if (focusIndex < 0) {
				focusIndex = 0
			} else if (focusIndex > lastItemIndex) {
				focusIndex = lastItemIndex
			}

			event.preventDefault()
			const notDisabledButton = optionsCover.querySelectorAll('button:not([disabled])')[
				focusIndex
			] as HTMLElement
			notDisabledButton.focus()
		}
	}

	onDestroy(() => (focusIndex = -1))
</script>

<svelte:window onkeydown={handleKeyDown} />

<div bind:this={optionsCover}>
	{@render children?.()}
</div>
